module.exports = __webpack_public_path__ + "img/atendimentos-na-esb.175a7059.svg";